const STORAGE_KEY_PREFIX = 'mp-agents-last-active-chat'

function getStorageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}-${userId}`
}

function isValidChatId(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0 && value.length < 256
}

/**
 * Load the last active chat ID from localStorage.
 * Safe: SSR guard, try/catch, validates format.
 */
export function loadLastActiveChatId(userId: string): string | null {
  if (typeof window === 'undefined') return null
  try {
    const stored = localStorage.getItem(getStorageKey(userId))
    if (!stored) return null
    return isValidChatId(stored) ? stored : null
  } catch {
    return null
  }
}

/**
 * Save the last active chat ID to localStorage.
 * Safe: SSR guard, try/catch. Pass undefined to clear.
 */
export function saveLastActiveChatId(userId: string, chatId: string | undefined): void {
  if (typeof window === 'undefined') return
  try {
    const key = getStorageKey(userId)
    if (chatId && isValidChatId(chatId)) {
      localStorage.setItem(key, chatId)
    } else {
      localStorage.removeItem(key)
    }
  } catch {
    // Quota exceeded, private mode, etc.
  }
}
